import React, { ReactElement } from 'react';
import { FilterTag, FilterTagGroup } from 'slovlex-idsk-react-components';
import classNames from 'classnames';
import PublikovanyTerminFilter from '../../../model/PublikovanyTerminFilter';
import { SafeParameterSetter } from '../../../model/SafeParameterSetter';

interface Props {
  filter: PublikovanyTerminFilter;
  onUpdateField: SafeParameterSetter<PublikovanyTerminFilter>;
  className?: string;
  /**
   * Pre desktop. V mobilnom modale ma tlacidlo na starosti MobileFilterModal,
   * takze tam sa nechava nevyplnene.
   */
  onClearFilters?: () => void;
}

const FilterTagsComponent = ({
  filter,
  onUpdateField,
  className = '',
  onClearFilters = null,
}: Props): ReactElement => {
  const classes: string = classNames('tezaury-filter-tag-component', className);

  return (
    <FilterTagGroup className={classes} onClearFilters={onClearFilters}>
      <FilterTag
        title="Hľadaný termín"
        data={filter.searchTextHladanyTermin}
        onClear={() => {
          onUpdateField('searchTextHladanyTermin', '');
        }}
      />
      <FilterTag
        title="Tezaurus"
        data={filter?.tezaurus?.nazov}
        onClear={() => onUpdateField('tezaurus', null)}
      />
      <FilterTag
        title="Legálny zdroj"
        data={filter.searchTextLegalnyZdroj}
        onClear={() => {
          onUpdateField('searchTextLegalnyZdroj', '');
        }}
      />
      <FilterTag
        title="Doktrinálny zdroj"
        data={filter.searchTextDoktrinalnyZdroj}
        onClear={() => {
          onUpdateField('searchTextDoktrinalnyZdroj', '');
        }}
      />
      <FilterTag
        title="Použité v právnom predpise"
        data={filter.pouzitiePredpisList.map(predpis => predpis?.popis)}
        onClear={(title) => onUpdateField(
          'pouzitiePredpisList',
          filter.pouzitiePredpisList.filter(predpis => predpis.popis !== title),
        )}
      />
    </FilterTagGroup>
  );
};

export default FilterTagsComponent;
